import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteWidgetsMutation } from "../graphql/mutations";
import type {
  DeleteWidgetsMutationType,
  DeleteWidgetsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteWidgetsMutation = (
  options?: MutationHookOptions<
    DeleteWidgetsMutationType,
    DeleteWidgetsMutationVariablesType
  >
) => {
  return useMutation<
    DeleteWidgetsMutationType,
    DeleteWidgetsMutationVariablesType
  >(DeleteWidgetsMutation, options);
};
